import React, { useEffect, useState } from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import MarksCard from "./MarksCard";
import Header from "../MainLayout/Header";
import MySnackbar from "../MyComponents/MySnackbar";
import { set } from "store";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

const AddMarksForStudents = (props) => {
  const [studentList, setStudentList] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [gradingData, setGradingData] = useState([]);
  const [snackbar, setSnackbar] = useState(false);
  const [failedSnackbar, setFailedSnackbar] = useState(false);

  useEffect(() => {
    fetchData({
      session: props.user.session.id,
      student_class: props.match.params.class,
      student_section: props.match.params.section,
      exam_id: props.match.params.subjectid,
      exam_system_type: props.match.params.typeid,
    });
  }, []);

  const fetchData = (params = {}) => {
    axios.get(`/api/ExamMarksMulti`, { params: { ...params } }).then((res) => {
      const sortedStudentList = res.data.student_list.sort(
        (a, b) => a.roll_no - b.roll_no
      );
      setStudentList(sortedStudentList);
      setStudentList(res.data.student_list);
      setStudentData(res.data.student_list);
      setGradingData(res.data.grading_pattern_data);
    });
  };

  const onChangeMarks = (index, newMarks) => {
    let student = studentData[index];
    if (newMarks > student.student_type_data[0].exam__max_marks) {
      setFailedSnackbar(true);
      handleSnackbar();
      return;
    }
    student.student_type_data[0].marks_obtained = newMarks;
    studentData[index] = student;
    setStudentData(studentData);
  };

  const onChangeAttendanceStatus = (index, attendance) => {
    let student = studentData[index];
    student.student_type_data[0].attendence = attendance;
    studentData[index] = student;
    setStudentData(studentData);
  };

  const onSubmit = () => {
    axios.post("/api/ExamMarksMulti", { result: studentData }).then(() => {
      setSnackbar(true);
      fetchData({
        session: props.user.session.id,
        student_class: props.match.params.class,
        student_section: props.match.params.section,
        exam_id: props.match.params.subjectid,
        exam_system_type: props.match.params.typeid,
      });
    });
    handleSnackbar();
  };

  const handleSnackbar = () => {
    setTimeout(() => {
      setSnackbar(false);
      setFailedSnackbar(false);
    }, 3000);
  };

  const { classname, sectionname, typename, subjectId } = props.match.params;

  return (
    <>
      <Header to="/home" title="Add Marks" />
      <div className="container mt-2 pb-5">
        <div className="th-14 row ml-1">
          <div className="col-6">
            <span className="th-12 th-fw-600 pr-2">Class:</span>

            {classname}
          </div>
          <div className="col-6">
            <span className="th-12 th-fw-600 pr-2">Section:</span>

            {sectionname}
          </div>
          <div className="col-6">
            <span className="th-12 th-fw-600 pr-2">Exam Type:</span>

            {typename}
          </div>
          <div className="col-6">
            <span className="th-12 th-fw-600 pr-2">Subject:</span>

            {studentData[0]?.student_type_data[0]?.subject}
          </div>
        </div>
        <div>
          {studentList.map((student, index) => (
            <div key={student.id}>
              <MarksCard
                sno={index}
                student={student}
                gradingData={gradingData}
                onChangeMarks={onChangeMarks}
                onChangeAttendanceStatus={onChangeAttendanceStatus}
              />
            </div>
          ))}
        </div>
        <div className="mb-5 pb-4 text-center fixed-bottom">
          <button
            className="th-btn-primary py-2 px-3 th-14"
            onClick={onSubmit}
            style={{
              background:
                "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
              width: "90%",
            }}
          >
            SUBMIT MARKS
          </button>
        </div>
      </div>
      {snackbar ? <MySnackbar title="Updated Successfully" /> : null}
      {failedSnackbar ? (
        <MySnackbar title="Obtained marks can not be greater than maximum marks" />
      ) : null}
    </>
  );
};

export default withRouter(connect(mapStateToProps)(AddMarksForStudents));
